import PropTypes from 'prop-types';
import { useLayoutEffect, useState, useRef } from 'react';
import OverlayNode from 'components/overlay-node';
import { useEditor } from 'pages/editor/editor-context';

function HighlightNodeById({ document, id }) {
  const { html } = useEditor();
  const [element, setElement] = useState();
  const overlayRef = useRef(null);

  useLayoutEffect(() => {
    if (document && document.body.hasChildNodes() && id) {
      const node = document.querySelector(`[data-id='${id}']`);
      setElement(node);
    }
  }, [document, id, html]);

  if (!element || !id) return null;

  return (
    <OverlayNode
      key={`${id}_overlay`}
      ref={overlayRef}
      document={document}
      element={element}
      type="dashed"
      id={id}
    />
  );
}

HighlightNodeById.propTypes = {
  document: PropTypes.shape({
    body: PropTypes.shape({
      hasChildNodes: PropTypes.func,
    }),
    querySelector: PropTypes.func,
  }),
  id: PropTypes.string,
};

HighlightNodeById.defaultProps = {
  document: null,
  id: '',
};

export default HighlightNodeById;
